import { AxiosResponse } from "axios";
import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const authForgotPassword = catchAsync(
  async (body: { email: string }) => {
    const res = await axiosInstance.post("salon/forget-password", body);
    console.log("authForgotPassword  data:", res.data);
    return res;
  }
);

export const authSocialLogin = catchAsync(
  async (provider: string, body: any) => {
    const url = axiosInstance.getUri();
    axiosInstance.defaults.baseURL = url.replace("/v1", "");
    const res = await axiosInstance.post(`/auth/callback/${provider}`, body);
    return res;
  }
);

export const authLogin = async (body: {
  password?: string;
  email?: string;
  phone?: string;
  phone_country_code?: string;
}): Promise<AxiosResponse> => {
  return await axiosInstance.post("login", body);
};

export const authRegister = catchAsync(
  async (body: {
    email: string;
    password: string;
    password_confirmation: string;
    name: string;
    phone: string;
    phone_country_code: string;
  }): Promise<AxiosResponse> => {
    const res = await axiosInstance.post("salon/register", body);

    return res;
  }
);

export const authReSendOtp = catchAsync(
  async (body: { phone: string }): Promise<AxiosResponse> => {
    return await axiosInstance.post("salon/resend-otp-code", body);
  }
);
export const authVerifyOtp = catchAsync(
  async (body: { phone: string; code: string }): Promise<AxiosResponse> => {
    return await axiosInstance.post("salon/otp-verification", body);
  }
);
export const authResetPassword = catchAsync(
  async (body: {
    password: string;
    password_confirmation: string;
    token: string;
  }): Promise<AxiosResponse> => {
    const res = await axiosInstance.post("salon/reset-password", body);

    return res;
  }
);export const authChangePassword = catchAsync(
  async (body: {
    salon_id:number | string
    old_password: string;
    password: string;
    password_confirmation: string;
  }): Promise<AxiosResponse> => {
    const res = await axiosInstance.post("salon/change-password", body);

    return res;
  }
);

//todo get the useDetails from the backend
export const authUserDetails = async (body: {
  email: string;
  password: string;
}): Promise<AxiosResponse> => {
  return await axiosInstance.post("login", body);
};
export const getAuthUserDetails = async () => {
  return await axiosInstance.get("auth");
};

export const sendOTP = async (body: {
  phone?: string;
  phone_country_code?: string;
}): Promise<AxiosResponse> => {
  return await axiosInstance.post("send", body);
};
export const verifyOTP = async (body: {
  phone: string;
  phone_country_code: string;
  code: string;
}): Promise<AxiosResponse> => {
  return await axiosInstance.post("verify", body);
};

export const AddUserAuthSocial = (url: any) => {
  return axiosInstance.get("/auth/callback/google" + url);
};
